import { Injectable } from '@angular/core';
import { UtilsManager } from 'src/app/managers/utils/utils.manager';
import { NotifierManager } from 'src/app/managers/notifier/notifier.manager';
import { Notifier } from 'src/app/enums/notifier/notifier.enum';
import { NotifierMessage } from 'src/app/enums/notifier/message/notifier.enum';
import { RequestManager } from 'src/app/managers/request/request.manager';
import { ErrorManager } from 'src/app/managers/error/error.manager';
import { Site } from 'src/app/beans/site/site.bean';
import { SiteDetail } from 'src/app/beans/site/site.detail';
;

@Injectable({
  providedIn: 'root'
})
export class SiteHandler
{
    constructor(
      private _utils    : UtilsManager    ,
      private _notifier : NotifierManager ,
      private _request  : RequestManager  ,
      private _error    : ErrorManager
    ) { }

    async list(token: string, organizationId: number, enabled: number)
    {      
        if (!this._utils.checker().isValidText(token)) 
        {
          this._notifier.show( 
            Notifier.WARNING, 
            NotifierMessage.INVALID_PASSWORD
          )
          return undefined
        } 

        if (!this._utils.checker().isValidId(organizationId)){
          this._notifier.show( 
            Notifier.WARNING, 
            NotifierMessage.INVALID_ORG_ID
          )
          return undefined
        }

        try
        {
          const response = await this._request.site().list( token, organizationId, enabled).toPromise()

          if (this._error.hasError(response)){
            // MANAGE ERROR
            return this._error.handleCQWebapp ( response ) 
          }

          return response as Site[]
        }catch(error)
        {
          // this._error.handleNetwork ( error )  
          return undefined
        }
    }

    async detail(token: string, siteId: number)
    {      
        if (!this._utils.checker().isValidText(token)) 
        {
          this._notifier.show( 
            Notifier.WARNING, 
            NotifierMessage.INVALID_PASSWORD
          )
          return undefined
        } 

        if (!this._utils.checker().isValidId(siteId)){
          this._notifier.show( 
            Notifier.WARNING, 
            NotifierMessage.INVALID_SITE_ID
          )
          return undefined
        }

        try
        {
          const response = await this._request.site().detail( token, siteId ).toPromise()

          if (this._error.hasError(response)){
            // MANAGE ERROR
            return this._error.handleCQWebapp ( response ) 
          }

          return response as Site[]
        }catch(error)
        {
          // this._error.handleNetwork ( error )  
          return undefined
        }
    }

    async create(token: string, orgId: number, site: SiteDetail)
    {
        if (!this._utils.checker().isValidText(token)) 
        {
          this._notifier.show( 
            Notifier.WARNING, 
            NotifierMessage.INVALID_PASSWORD
          )
          return undefined
        }
        
        if(!this._utils.checker().isValidId(orgId)) 
        {
          this._notifier.show
          ( 
            Notifier.WARNING, 
            NotifierMessage.INVALID_ORG_ID
          )
          return undefined
        }

        if (!this._utils.checker().isValidText(site.name)) 
        {
          this._notifier.show( 
            Notifier.WARNING, 
            NotifierMessage.INVALID_SITE_NAME
          )
          return undefined
        }

        if (!this._utils.checker().isValidId(site.zipCode)) 
        {
          this._notifier.show( 
            Notifier.WARNING, 
            NotifierMessage.INVALID_SITE_ZIPCODE
          )
          return undefined
        }

        if (!this._utils.checker().isValidText(site.address)) 
        {
          this._notifier.show( 
            Notifier.WARNING, 
            NotifierMessage.INVALID_SITE_ADDRESS
          )
          return undefined
        }

        if (!this._utils.checker().isValidId(site.latitude)) 
        {
          this._notifier.show( 
            Notifier.WARNING, 
            NotifierMessage.INVALID_SITE_LATITUDE
          )
          return undefined
        }

        if (!this._utils.checker().isValidId(site.longitude)) 
        {
          this._notifier.show( 
            Notifier.WARNING, 
            NotifierMessage.INVALID_SITE_LONGITUDE
          )
          return undefined
        }

        if (!this._utils.checker().isValidId(site.placeId)) 
        {
          this._notifier.show( 
            Notifier.WARNING, 
            NotifierMessage.INVALID_SITE_PLACE_ID
          )
          return undefined
        }

        try
        {
          const response = await this._request.site().create( token, orgId, JSON.stringify(site)).toPromise()

          if (this._error.hasError(response))
          {
            // MANAGE ERROR
            return this._error.handleCQWebapp ( response ) 
          }
          else 
          {
            this._notifier.show
            ( 
              Notifier.SUCCESS            , 
              NotifierMessage.OPERATION_OK
            )
            return response
          }

        }catch(error)
        {
          // this._error.handleNetwork ( error )  
          return undefined
        }
    }

    async update(token: string, site: SiteDetail)
    {      
        if (!this._utils.checker().isValidText(token)) 
        {
          this._notifier.show( 
            Notifier.WARNING, 
            NotifierMessage.INVALID_PASSWORD
          )
          return undefined
        } 

        if (!this._utils.checker().isValidId(site.id))
        {
          this._notifier.show( 
            Notifier.WARNING, 
            NotifierMessage.INVALID_SITE_ID
          )
          return undefined
        }

        if (!this._utils.checker().isValidText(site.name)) 
        {
          this._notifier.show( 
            Notifier.WARNING, 
            NotifierMessage.INVALID_SITE_NAME
          )
          return undefined
        }

        if (!this._utils.checker().isValidId(site.zipCode)) 
        {
          this._notifier.show( 
            Notifier.WARNING, 
            NotifierMessage.INVALID_SITE_ZIPCODE
          )
          return undefined
        }

        if (!this._utils.checker().isValidText(site.address)) 
        {
          this._notifier.show( 
            Notifier.WARNING, 
            NotifierMessage.INVALID_SITE_ADDRESS
          )
          return undefined
        }

        if (!this._utils.checker().isValidId(site.latitude)) 
        {
          this._notifier.show( 
            Notifier.WARNING, 
            NotifierMessage.INVALID_SITE_LATITUDE
          )
          return undefined
        }

        if (!this._utils.checker().isValidId(site.longitude)) 
        {
          this._notifier.show( 
            Notifier.WARNING, 
            NotifierMessage.INVALID_SITE_LONGITUDE
          )
          return undefined
        }

        if (!this._utils.checker().isValidId(site.placeId)) 
        {
          this._notifier.show( 
            Notifier.WARNING, 
            NotifierMessage.INVALID_SITE_PLACE_ID
          )
          return undefined
        }

        try
        {
          const response = await this._request.site().update( token, site.id, JSON.stringify(site) ).toPromise()

          if (this._error.hasError(response))
          {
            // MANAGE ERROR
            return this._error.handleCQWebapp ( response ) 
          }
          else 
          {
            this._notifier.show
            ( 
              Notifier.SUCCESS            , 
              NotifierMessage.OPERATION_OK
            )
            return response
          }

        }catch(error)
        {
          // this._error.handleNetwork ( error )  
          return undefined
        }
    }

    async listByServiceCode(token: string, orgId: number, serviceId: number, serviceCode: string, enabled: number)
    {      
        if (!this._utils.checker().isValidText(token)) 
        {
          this._notifier.show( 
            Notifier.WARNING, 
            NotifierMessage.INVALID_PASSWORD
          )
          return undefined
        } 

        if (!this._utils.checker().isValidId(serviceId)){
          this._notifier.show( 
            Notifier.WARNING, 
            NotifierMessage.INVALID_SERVICE_ID
          )
          return undefined
        }

        try
        {
          const response = await this._request.site().listByServiceCode( token, orgId, serviceId, serviceCode, enabled).toPromise()

          if (this._error.hasError(response)){
            // MANAGE ERROR
            return this._error.handleCQWebapp ( response ) 
          }

          return response as Site[]
        }catch(error)
        {
          // this._error.handleNetwork ( error )  
          return undefined
        }
    }
}

